import React, { PureComponent } from 'react';
import { Line } from 'rc-progress';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';
import { useTranslation } from 'react-i18next';

const CustomTooltip = ({ active, payload, maxValue }) => {
    const { t } = useTranslation();
    if (active && payload && payload.length) {
        const { obtainedScore, totalPossibleMarks, averageScore } = payload[0].payload;

        return (
            <div className="custom-tooltip text-center" style={{ backgroundColor: '#f7ecec', padding: '10px', borderRadius: '5px' }}>
                <p className="label mb-0" style={{ fontWeight: 'bold', color: "#858585" }}>{t("Average score")}</p>
                <p className="intro mb-0" style={{ color: "#AE3E3E", fontWeight: 'bold' }}>
                    {`${obtainedScore}/${totalPossibleMarks}`}
                </p>
                <div>
                    <Line percent={averageScore} strokeWidth={8} strokeColor="#AE3E3E" trailColor="#ffffff" />
                </div>
            </div>
        );
    }

    return null;
};
const StudentStatistics = ({ statsData }) => {
    const { t } = useTranslation();
    const data = statsData?.map(item => ({
        name: t(item.assignmentTitle), // Assignment title from statsData
        obtainedScore: item.obtainedScore, // Obtained score from statsData
        totalPossibleMarks: item.totalPossibleMarks, // Total score from statsData
        averageScore: item.averageScore // Average score from statsData
    }));

    // Find the maximum score to normalize the percentage in the tooltip
    const maxValue = Math.max(...data?.map(item => item?.totalPossibleMarks));
    if (!statsData || statsData?.length === 0) {
        return <div className='d-flex align-items-center justify-content-center py-4'>
            {t("No Data")}
        </div>
    }
    return (
        <ResponsiveContainer className={"my-4"} width="100%" height={400}>
            <BarChart
                width={500}
                height={300}
                data={data}
                margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
            >
                <defs>
                    <linearGradient id="gradient" x1="0" y1="0" x2="1" y2="0">
                        <stop offset="0%" stopColor="#EC7677" />
                        <stop offset="100%" stopColor="#DE494B" />
                    </linearGradient>
                </defs>
                <CartesianGrid strokeDasharray="3 1" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip content={<CustomTooltip maxValue={maxValue} />} />
                <Bar
                    dataKey="averageScore"
                    fill="url(#gradient)"
                    barSize={20}
                    radius={[10, 10, 0, 0]}
                >
                    {data.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={`url(#gradient)`} />
                    ))}
                </Bar>
            </BarChart>
        </ResponsiveContainer>
    )
}

export default StudentStatistics
